import { render, staticRenderFns } from "./proposals-promo.vue?vue&type=template&id=42755eb6"
import script from "./proposals-promo.vue?vue&type=script&lang=js"
export * from "./proposals-promo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports